import React from 'react'
import PropTypes from 'prop-types'
import { Modal, Level, Button, Link } from '@deseretbook/react-ui'
import { Slices } from '../../prismic'

/**
 * Subscription details view of the subscription signup modal.
 *
 * @returns {function} Component
 */
const DetailsView = ({
  user,
  subscriptionForm,
  detailsDocument,
  changeView,
}) => {
  const { data: displayDetails = {} } = detailsDocument
  let footerActionContent

  // If the form is initialized but the user can't create aa subscription because they aren't
  // logged in.
  if (!subscriptionForm.userCanCreate && subscriptionForm.isInitialized && !user) {
    footerActionContent = (
      <Level.Item>
        <Button
          asComponent={Link}
          color="action"
          href="/login"
          isLoading={subscriptionForm.isLoading}
        >
          Login to Begin
        </Button>
      </Level.Item>
    )
  }

  // Default button if the form hasn't been initialized yet or if it has and the user can create
  // the subscription.
  if (subscriptionForm.userCanCreate || !subscriptionForm.isInitialized) {
    footerActionContent = (
      <Level.Item>
        <Button
          color="action"
          type="button"
          onClick={() => changeView('form')}
          isLoading={subscriptionForm.isLoading || !subscriptionForm.isInitialized}
        >
          Sign Up Now
        </Button>
      </Level.Item>
    )
  }

  return (
    <React.Fragment>
      <Modal.Content>
        <Slices slices={displayDetails.detailsSlices} user={user} />
      </Modal.Content>
      {footerActionContent && (
        <Modal.Footer>
          <Level>
            <Level.Right>
              {footerActionContent}
            </Level.Right>
          </Level>
        </Modal.Footer>
      )}
    </React.Fragment>
  )
}

DetailsView.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.number,
  }),
  subscriptionForm: PropTypes.shape({
    isLoading: PropTypes.bool,
    isInitialized: PropTypes.bool,
    userCanCreate: PropTypes.bool,
    selectedEstimate: PropTypes.shape({
      trialPeriod: PropTypes.bool,
    }),
  }),
  detailsDocument: PropTypes.shape({
    data: PropTypes.shape({
      detailsSlices: PropTypes.array,
    }),
  }),
  changeView: PropTypes.func,
}

DetailsView.defaultProps = {
  user: null,
  subscriptionForm: {},
  detailsDocument: {},
  changeView: () => {},
}

export default DetailsView
